import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useTagsState() {
  return useAppState();
}

export function useTagsActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      filterOptionsModalIsOpen: false,
      pageNumber: null,
      numberOfPages: 1,
      tags: [],
      filterOptions: null,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    clearFeedback,
  };
}
